import { Stack, Typography } from '@mui/material'

import { SpaceBox } from 'components/Box'
import Space from 'components/Space'
import { TableHeaderProps } from './types'

export const TableHeader = ({
  actions,
  description,
  descriptionEndAdornment,
  filter,
  save,
  title,
}: TableHeaderProps): React.JSX.Element => (
  <Stack sx={{ gap: 1 }}>
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography
        data-cy='table-header-title'
        variant='h5'
      >
        {title}
      </Typography>

      {actions}

      <SpaceBox />

      {save ?? filter}
    </Stack>

    {description && (
      <Typography
        data-cy='table-header-description'
        variant='subtitle1'
      >
        {description}

        {descriptionEndAdornment && <Space />}
        {descriptionEndAdornment}
      </Typography>
    )}

    {save && filter && <Stack sx={{ alignItems: 'flex-end' }}>{filter}</Stack>}
  </Stack>
)
